// Auto-generated by gatsby-theme onPreBootstrap. Do not edit.
// Source: index.ts barrel exports under src/assets/icons

import * as React from "react";

import { ReactComponent as __AccessoriesIcon } from "../assets/icons/product-category/accessories.svg";
import { ReactComponent as __AccountIcon } from "../assets/icons/nav/account.svg";
import { ReactComponent as __AddToCartIcon } from "../assets/icons/base/add-to-cart.svg";
import { ReactComponent as __ApparelAccessoriesIcon } from "../assets/icons/product-category/apparel-accessories.svg";
import { ReactComponent as __ArrowCloseIcon } from "../assets/icons/base/arrow-close.svg";
import { ReactComponent as __ArrowHeavyIcon } from "../assets/icons/nav/arrow-right.svg";
import { ReactComponent as __ArrowIcon } from "../assets/icons/base/arrow.svg";
import { ReactComponent as __BackToVideoIcon } from "../assets/icons/base/back-to-video.svg";
import { ReactComponent as __BallCareIcon } from "../assets/icons/product-category/ball-care.svg";
import { ReactComponent as __BallsIcon } from "../assets/icons/base/balls-icon.svg";
import { ReactComponent as __BeardCareIcon } from "../assets/icons/product-category/beard-care.svg";
import { ReactComponent as __BeardFaceIcon } from "../assets/icons/product-category/beard-face.svg";
import { ReactComponent as __BeardKitsIcon } from "../assets/icons/product-category/beard-kits.svg";
import { ReactComponent as __BladeReplacementsIcon } from "../assets/icons/product-category/blade-replacements.svg";
import { ReactComponent as __BodyCareIcon } from "../assets/icons/product-category/body-care.svg";
import { ReactComponent as __BodyIcon } from "../assets/icons/product-category/body.svg";
import { ReactComponent as __BodyKitIcon } from "../assets/icons/product-category/body-kit.svg";
import { ReactComponent as __CalendarIcon } from "../assets/icons/base/calendar.svg";
import { ReactComponent as __CancelledIcon } from "../assets/icons/base/cancelled.svg";
import { ReactComponent as __CarrotIcon } from "../assets/icons/base/carrot.svg";
import { ReactComponent as __CartIcon } from "../assets/icons/base/cart.svg";
import { ReactComponent as __CheckIcon } from "../assets/icons/base/check.svg";
import { ReactComponent as __ChevronIcon } from "../assets/icons/base/chevron.svg";
import { ReactComponent as __ChevronNav } from "../assets/icons/nav/chevron-nav.svg";
import { ReactComponent as __ChevronRightIcon } from "../assets/icons/base/chevron-right.svg";
import { ReactComponent as __CloseIcon } from "../assets/icons/base/close.svg";
import { ReactComponent as __CologneQualityIcon } from "../assets/icons/ingredients/cologne-quality.svg";
import { ReactComponent as __CrossOutIcon } from "../assets/icons/base/cross-out.svg";
import { ReactComponent as __CrownIcon } from "../assets/icons/ms/crown.svg";
import { ReactComponent as __CrueltyFreeIcon } from "../assets/icons/ingredients/cruelty-free.svg";
import { ReactComponent as __DealsIcon } from "../assets/icons/product-category/deals.svg";
import { ReactComponent as __DealsKitsIcon } from "../assets/icons/product-category/deals-kits.svg";
import { ReactComponent as __DyeFreeIcon } from "../assets/icons/ingredients/dye-free.svg";
import { ReactComponent as __EditIcon } from "../assets/icons/base/edit.svg";
import { ReactComponent as __EraseIcon } from "../assets/icons/base/erase.svg";
import { ReactComponent as __ErrorIcon } from "../assets/icons/base/error.svg";
import { ReactComponent as __FacebookIcon } from "../assets/icons/social/facebook.svg";
import { ReactComponent as __FaceKitsIcon } from "../assets/icons/product-category/face-kits.svg";
import { ReactComponent as __FAQAccountHelpIcon } from "../assets/icons/faq/account-help.svg";
import { ReactComponent as __FAQGeneralIcon } from "../assets/icons/faq/general.svg";
import { ReactComponent as __FAQHelpWithMyOrderIcon } from "../assets/icons/faq/help-with-my-order.svg";
import { ReactComponent as __FAQMembersOnlyRewardsIcon } from "../assets/icons/faq/members-only-rewards.svg";
import { ReactComponent as __FAQProductIcon } from "../assets/icons/faq/product.svg";
import { ReactComponent as __FAQWarrantyReturnsIcon } from "../assets/icons/faq/warranty-returns.svg";
import { ReactComponent as __GroinIcon } from "../assets/icons/product-category/groin.svg";
import { ReactComponent as __GroinKitsIcon } from "../assets/icons/product-category/groin-kits.svg";
import { ReactComponent as __HandsAndFeetIcon } from "../assets/icons/product-category/hands-feet.svg";
import { ReactComponent as __HeadBodyIcon } from "../assets/icons/product-category/HeadBodyIcon.svg";
import { ReactComponent as __HeadCareIcon } from "../assets/icons/product-category/HeadCareIcon.svg";
import { ReactComponent as __HighVisibilityIcon } from "../assets/icons/ingredients/high-visibility.svg";
import { ReactComponent as __IdMeIcon } from "../assets/icons/ms/id-ms.svg";
import { ReactComponent as __InfoIcon } from "../assets/icons/base/info.svg";
import { ReactComponent as __InstagramIcon } from "../assets/icons/social/instagram.svg";
import { ReactComponent as __LeftSwooshSvg } from "../assets/icons/swoosh/left-swoosh.svg";
import { ReactComponent as __LinkedInIcon } from "../assets/icons/social/linkedin.svg";
import { ReactComponent as __ManscapedLogo } from "../assets/icons/ms/manscaped-logo.svg";
import { ReactComponent as __MenuIcon } from "../assets/icons/base/menu.svg";
import { ReactComponent as __MinusIcon } from "../assets/icons/base/minus.svg";
import { ReactComponent as __MoneyBackDeIcon } from "../assets/icons/ms/money-back-de.svg";
import { ReactComponent as __MoneyBackEsIcon } from "../assets/icons/ms/money-back-es.svg";
import { ReactComponent as __MoneyBackFrIcon } from "../assets/icons/ms/money-back-fr.svg";
import { ReactComponent as __MoneyBackIcon } from "../assets/icons/ms/money-back.svg";
import { ReactComponent as __MoneyBackSimpleIcon } from "../assets/icons/ms/money-back-simple.svg";
import { ReactComponent as __MoreInfoIcon } from "../assets/icons/base/more-info.svg";
import { ReactComponent as __MyAccountIcon } from "../assets/icons/account/account.svg";
import { ReactComponent as __MyRewardsIcon } from "../assets/icons/account/my-rewards.svg";
import { ReactComponent as __NavDropDownCloseIcon } from "../assets/icons/nav/close-dropdown.svg";
import { ReactComponent as __OrderHistoryIcon } from "../assets/icons/account/order-history.svg";
import { ReactComponent as __OrderReplenishmentIcon } from "../assets/icons/account/order-replenishment.svg";
import { ReactComponent as __OverviewIcon } from "../assets/icons/account/overview.svg";
import { ReactComponent as __ParabenFreeIcon } from "../assets/icons/ingredients/paraben-free.svg";
import { ReactComponent as __PauseCircleIcon } from "../assets/icons/base/PauseCircleIcon.svg";
import { ReactComponent as __PauseIcon } from "../assets/icons/base/PauseIcon.svg";
import { ReactComponent as __PhpIcon } from "../assets/icons/ms/php.svg";
import { ReactComponent as __PinterestIcon } from "../assets/icons/social/pinterest.svg";
import { ReactComponent as __PlayCircleIcon } from "../assets/icons/base/PlayCircleIcon.svg";
import { ReactComponent as __PlayIcon } from "../assets/icons/base/PlayIcon.svg";
import { ReactComponent as __PlusCircleIcon } from "../assets/icons/base/plus-circle.svg";
import { ReactComponent as __PlusIcon } from "../assets/icons/base/plus.svg";
import { ReactComponent as __PrioritySupportIcon } from "../assets/icons/account/priority-support.svg";
import { ReactComponent as __ProcessingIcon } from "../assets/icons/base/processing.svg";
import { ReactComponent as __QuoraIcon } from "../assets/icons/social/quora.svg";
import { ReactComponent as __RadioCheckedIcon } from "../assets/icons/base/radio-checked.svg";
import { ReactComponent as __RadioUnCheckedIcon } from "../assets/icons/base/radio-unchecked.svg";
import { ReactComponent as __RegularPriceIcon } from "../assets/icons/ms/regular-price.svg";
import { ReactComponent as __ReturnsIcon } from "../assets/icons/base/returns.svg";
import { ReactComponent as __RightSwooshSvg } from "../assets/icons/swoosh/right-swoosh.svg";
import { ReactComponent as __RingIcon } from "../assets/icons/base/ring.svg";
import { ReactComponent as __RulerIcon } from "../assets/icons/base/ruler.svg";
import { ReactComponent as __SearchIcon } from "../assets/icons/base/search.svg";
import { ReactComponent as __SecureIcon } from "../assets/icons/ms/secure.svg";
import { ReactComponent as __ShippingIcon } from "../assets/icons/ms/shipping.svg";
import { ReactComponent as __ShippingTruckIcon } from "../assets/icons/ms/shipping-truck.svg";
import { ReactComponent as __SignOutIcon } from "../assets/icons/account/sign-out.svg";
import { ReactComponent as __SkinCareIcon } from "../assets/icons/product-category/skin-care.svg";
import { ReactComponent as __SkinCareKitsIcon } from "../assets/icons/product-category/SkinCareKitsIcon.svg";
import { ReactComponent as __SliderIcon } from "../assets/icons/base/slider.svg";
import { ReactComponent as __SuccessIcon } from "../assets/icons/base/success.svg";
import { ReactComponent as __TikTokIcon } from "../assets/icons/social/tiktok.svg";
import { ReactComponent as __ToolBundlesIcon } from "../assets/icons/product-category/ToolBundlesIcon.svg";
import { ReactComponent as __ToolsTrimmersBladesIcon } from "../assets/icons/product-category/tools-trimmers-blades.svg";
import { ReactComponent as __TranscriptIcon } from "../assets/icons/base/transcript.svg";
import { ReactComponent as __TrashIcon } from "../assets/icons/base/trash.svg";
import { ReactComponent as __TravelKitsIcon } from "../assets/icons/product-category/travel-kits.svg";
import { ReactComponent as __TriangleIcon } from "../assets/icons/base/triangle.svg";
import { ReactComponent as __TwitchIcon } from "../assets/icons/social/twitch.svg";
import { ReactComponent as __TwitterXIcon } from "../assets/icons/social/twitter-x.svg";
import { ReactComponent as __VeganIcon } from "../assets/icons/ingredients/vegan.svg";
import { ReactComponent as __VipPackageIcon } from "../assets/icons/account/vip-package.svg";
import { ReactComponent as __YoutubeIcon } from "../assets/icons/social/youtube.svg";

export const iconMap = {
  AccessoriesIcon: __AccessoriesIcon,
  AccountIcon: __AccountIcon,
  AddToCartIcon: __AddToCartIcon,
  ApparelAccessoriesIcon: __ApparelAccessoriesIcon,
  ArrowCloseIcon: __ArrowCloseIcon,
  ArrowHeavyIcon: __ArrowHeavyIcon,
  ArrowIcon: __ArrowIcon,
  BackToVideoIcon: __BackToVideoIcon,
  BallCareIcon: __BallCareIcon,
  BallsIcon: __BallsIcon,
  BeardCareIcon: __BeardCareIcon,
  BeardFaceIcon: __BeardFaceIcon,
  BeardKitsIcon: __BeardKitsIcon,
  BladeReplacementsIcon: __BladeReplacementsIcon,
  BodyCareIcon: __BodyCareIcon,
  BodyIcon: __BodyIcon,
  BodyKitIcon: __BodyKitIcon,
  CalendarIcon: __CalendarIcon,
  CancelledIcon: __CancelledIcon,
  CarrotIcon: __CarrotIcon,
  CartIcon: __CartIcon,
  CheckIcon: __CheckIcon,
  ChevronIcon: __ChevronIcon,
  ChevronNav: __ChevronNav,
  ChevronRightIcon: __ChevronRightIcon,
  CloseIcon: __CloseIcon,
  CologneQualityIcon: __CologneQualityIcon,
  CrossOutIcon: __CrossOutIcon,
  CrownIcon: __CrownIcon,
  CrueltyFreeIcon: __CrueltyFreeIcon,
  DealsIcon: __DealsIcon,
  DealsKitsIcon: __DealsKitsIcon,
  DyeFreeIcon: __DyeFreeIcon,
  EditIcon: __EditIcon,
  EraseIcon: __EraseIcon,
  ErrorIcon: __ErrorIcon,
  FacebookIcon: __FacebookIcon,
  FaceKitsIcon: __FaceKitsIcon,
  FAQAccountHelpIcon: __FAQAccountHelpIcon,
  FAQGeneralIcon: __FAQGeneralIcon,
  FAQHelpWithMyOrderIcon: __FAQHelpWithMyOrderIcon,
  FAQMembersOnlyRewardsIcon: __FAQMembersOnlyRewardsIcon,
  FAQProductIcon: __FAQProductIcon,
  FAQWarrantyReturnsIcon: __FAQWarrantyReturnsIcon,
  GroinIcon: __GroinIcon,
  GroinKitsIcon: __GroinKitsIcon,
  HandsAndFeetIcon: __HandsAndFeetIcon,
  HeadBodyIcon: __HeadBodyIcon,
  HeadCareIcon: __HeadCareIcon,
  HighVisibilityIcon: __HighVisibilityIcon,
  IdMeIcon: __IdMeIcon,
  InfoIcon: __InfoIcon,
  InstagramIcon: __InstagramIcon,
  LeftSwooshSvg: __LeftSwooshSvg,
  LinkedInIcon: __LinkedInIcon,
  ManscapedLogo: __ManscapedLogo,
  MenuIcon: __MenuIcon,
  MinusIcon: __MinusIcon,
  MoneyBackDeIcon: __MoneyBackDeIcon,
  MoneyBackEsIcon: __MoneyBackEsIcon,
  MoneyBackFrIcon: __MoneyBackFrIcon,
  MoneyBackIcon: __MoneyBackIcon,
  MoneyBackSimpleIcon: __MoneyBackSimpleIcon,
  MoreInfoIcon: __MoreInfoIcon,
  MyAccountIcon: __MyAccountIcon,
  MyRewardsIcon: __MyRewardsIcon,
  NavDropDownCloseIcon: __NavDropDownCloseIcon,
  OrderHistoryIcon: __OrderHistoryIcon,
  OrderReplenishmentIcon: __OrderReplenishmentIcon,
  OverviewIcon: __OverviewIcon,
  ParabenFreeIcon: __ParabenFreeIcon,
  PauseCircleIcon: __PauseCircleIcon,
  PauseIcon: __PauseIcon,
  PhpIcon: __PhpIcon,
  PinterestIcon: __PinterestIcon,
  PlayCircleIcon: __PlayCircleIcon,
  PlayIcon: __PlayIcon,
  PlusCircleIcon: __PlusCircleIcon,
  PlusIcon: __PlusIcon,
  PrioritySupportIcon: __PrioritySupportIcon,
  ProcessingIcon: __ProcessingIcon,
  QuoraIcon: __QuoraIcon,
  RadioCheckedIcon: __RadioCheckedIcon,
  RadioUnCheckedIcon: __RadioUnCheckedIcon,
  RegularPriceIcon: __RegularPriceIcon,
  ReturnsIcon: __ReturnsIcon,
  RightSwooshSvg: __RightSwooshSvg,
  RingIcon: __RingIcon,
  RulerIcon: __RulerIcon,
  SearchIcon: __SearchIcon,
  SecureIcon: __SecureIcon,
  ShippingIcon: __ShippingIcon,
  ShippingTruckIcon: __ShippingTruckIcon,
  SignOutIcon: __SignOutIcon,
  SkinCareIcon: __SkinCareIcon,
  SkinCareKitsIcon: __SkinCareKitsIcon,
  SliderIcon: __SliderIcon,
  SuccessIcon: __SuccessIcon,
  TikTokIcon: __TikTokIcon,
  ToolBundlesIcon: __ToolBundlesIcon,
  ToolsTrimmersBladesIcon: __ToolsTrimmersBladesIcon,
  TranscriptIcon: __TranscriptIcon,
  TrashIcon: __TrashIcon,
  TravelKitsIcon: __TravelKitsIcon,
  TriangleIcon: __TriangleIcon,
  TwitchIcon: __TwitchIcon,
  TwitterXIcon: __TwitterXIcon,
  VeganIcon: __VeganIcon,
  VipPackageIcon: __VipPackageIcon,
  YoutubeIcon: __YoutubeIcon
} as const;

export type IconKey = keyof typeof iconMap;

export function isIconKey(x: string): x is IconKey {
  return x in iconMap;
}

export type IconComponent = React.ComponentType<React.SVGProps<SVGSVGElement>>;
